import { useDispatch } from 'react-redux';
import { useAuth } from '../components/Auth';
import notification from '../components/notification';
import { setLoader } from '../redux/slices/loader';
import { impersonateUser, stopImpersonatingUser } from '../utils/api-helper';

const useImpersonation = () => {
  const dispatch = useDispatch();
  const { switchUserSession } = useAuth();

  const changeImpersonation = async (request, errorMessage) => {
    try {
      dispatch(setLoader(true));
      const impersonateResp = await request();
      switchUserSession(impersonateResp?.data);
      return true;
    } catch (error) {
      notification('error', error?.response?.data?.error || errorMessage);
      return false;
    } finally {
      dispatch(setLoader(false));
    }
  };

  const startImpersonation = (userID) =>
    changeImpersonation(
      () => impersonateUser(userID),
      'Unable to impersonate user!'
    );

  const exitImpersonation = () =>
    changeImpersonation(stopImpersonatingUser, 'Unable to exit impersonation!');

  return { startImpersonation, exitImpersonation };
};

export default useImpersonation;
